<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { getAppConfig } from '../../../../common/config/app-config';
  import { brandActiveFilters } from '../../../brand/store/brand_store';
  import Text from '../../../common/components/Text.svelte';

  const dispatcher = createEventDispatcher();
  const { currency } = getAppConfig();

  function removeActiveFilter(filter, e) {
    $brandActiveFilters = $brandActiveFilters.filter(item => item !== filter);
    dispatcher('activeFilterRemoved', {
      filterToBeRemoved: filter,
      subCategory: e.target.dataset.subcat,
    });
  }

  function removeAllFilter() {
    $brandActiveFilters = [];
    dispatcher('allFilterRemoved');
  }
</script>

{#if $brandActiveFilters && $brandActiveFilters.length > 0}
  <div class="filter-list border-top">
    {#each $brandActiveFilters as active}
      <span class="badge rounded-pill border border-grey">
        {@html active}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <span
          on:click={e => removeActiveFilter(active, e)}
          data-subCat={active.includes(currency) ? 'price' : 'subFamilyEn'}
          class="c_icon_new c_icon_new--close close"
          aria-label="close"
        ></span>
      </span>
    {/each}
    {#if $brandActiveFilters.length > 0}
      <button on:click={() => removeAllFilter()} class="btn text-primary">
        <Text key="plp.clearAll" />
      </button>
    {/if}
  </div>
{/if}

<style lang="scss">
  @import '../../styles/colors.new.scss';

  .filter-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.8rem;
    background-color: $primary-white;
    padding: 20px 0 36px 0;

    .badge {
      font-size: 1.4rem;
      font-weight: 400;
      line-height: 16px;
      display: flex;
      align-items: center;
      padding: 12px;
      justify-content: center;
      align-items: center;
      gap: 12px;
      border: 1px solid $secondary-gray-02;
      color: $neutral-dark-02;

      .c_icon_new--close {
        font-size: 16px;
        color: $tertiary-blue-02;
      }
    }

    button {
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px;
    }
  }
</style>
